var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('p',{staticClass:"sm-spinner",class:{
      'global': _vm.isGlobal || _vm.popupOpen
    }},[_c('lottie',{attrs:{"options":_vm.options,"height":100,"width":100},on:{"animCreated":_vm.handleAnimation}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }